import { errorGetWacUrl } from 'owa-locstrings/lib/strings/errorgetwacurl.locstring.json';
import loc from 'owa-localize';
import handleSetViewStateFailure from './handleSetViewStateFailure';
import getAuthorizedFilePreviewUrl from '../../services/getAuthorizedFilePreviewUrl';
import {
    FileExtensionTypes,
    FilePreviewUrl,
    updateFilePreviewInformation,
    getSxSViewStore,
    SharePointFileViewState,
} from 'owa-group-files-hub-store';

import { lazySetIframePreviewState, PreviewPaneViewStateBase } from 'owa-sxsdata';

const MEDIA_AUTOPLAY = '&autoplay=1';

export default async function setViewStateForIframePreview(
    filePreviewUrl: FilePreviewUrl,
    fileViewState: SharePointFileViewState,
    optionalParameters: PreviewPaneViewStateBase
) {
    try {
        let previewUrl;
        if (filePreviewUrl) {
            previewUrl = filePreviewUrl.previewUrl;
        } else {
            previewUrl = await getAuthorizedFilePreviewUrl(fileViewState.url, 'PreviewInNewSxS');
            if (previewUrl) {
                updateFilePreviewInformation(fileViewState.id, {
                    previewUrl: previewUrl,
                    lastUpdateTime: new Date(),
                });
            }
        }

        if (previewUrl) {
            if (
                fileViewState.fileExtensionType == FileExtensionTypes.Audio ||
                fileViewState.fileExtensionType == FileExtensionTypes.Video
            ) {
                previewUrl += MEDIA_AUTOPLAY;
            }
            const setIframePreviewState = await lazySetIframePreviewState.import();
            setIframePreviewState(getSxSViewStore().viewState, previewUrl, optionalParameters);
        } else {
            throw new Error('Preview url is not valid');
        }
    } catch (error) {
        // errorGetWacUrl is a generic error message: "Something went wrong while the document preview was being created. Please try again later."
        await handleSetViewStateFailure(error, loc(errorGetWacUrl), getSxSViewStore().datapoint);
    }
}
